import LegalDocumentPage from "@/components/layout/LegalDocumentPage";
import { CONTACT_EMAIL } from "@/config/site";

const LAST_UPDATED = "February 22, 2026";

const sections = [
  {
    title: "1. Who We Are",
    paragraphs: [
      "Specialist Dental London is a private dental practice based in New Malden, London. For data protection purposes, we act as the data controller for personal information collected through this website and during patient care.",
    ],
  },
  {
    title: "2. Information We Collect",
    bullets: [
      "Contact details such as name, telephone number, email address, and postal address.",
      "Referral and clinical information, including medical history, radiographs, treatment notes, and uploaded files where relevant.",
      "Communication records from forms, phone calls, email, live chat, and WhatsApp messages.",
      "Technical website data needed for security and service operation.",
    ],
  },
  {
    title: "3. How We Collect Information",
    paragraphs: [
      "We collect personal data directly from you, from referring clinicians, and from records created while providing treatment and aftercare.",
    ],
  },
  {
    title: "4. Legal Bases for Processing",
    bullets: [
      "Provision and management of healthcare services, including specialist triage and treatment planning.",
      "Performance of a contract or steps requested before entering a contract.",
      "Legitimate interests in operating, improving, and safeguarding our services.",
      "Compliance with legal and regulatory obligations.",
      "Explicit consent where this is required by law.",
    ],
  },
  {
    title: "5. How We Use Personal Data",
    bullets: [
      "To review referrals, plan treatment, and deliver dental care.",
      "To contact patients, referrers, and authorised representatives about appointments and care.",
      "To maintain accurate clinical records, governance logs, and billing records.",
      "To meet legal, professional, and safeguarding duties.",
    ],
  },
  {
    title: "6. Sharing Personal Data",
    paragraphs: [
      "We only share personal data where necessary and lawful. This may include members of the clinical team, dental laboratories, secure technology suppliers, and authorities or insurers where legally required.",
    ],
  },
  {
    title: "7. Data Retention",
    paragraphs: [
      "Clinical and referral records are retained in line with applicable dental, regulatory, and legal retention requirements. Data is securely deleted or anonymised when no longer required.",
    ],
  },
  {
    title: "8. Security",
    paragraphs: [
      "We apply organisational and technical controls designed to protect confidentiality, integrity, and availability of personal data, including restricted access, secure systems, and staff confidentiality requirements.",
    ],
  },
  {
    title: "9. Your Rights",
    bullets: [
      "Access to your personal data.",
      "Correction of inaccurate or incomplete data.",
      "Restriction or objection to processing in specific circumstances.",
      "Erasure where there is no lawful reason for continued processing.",
      "Data portability where applicable.",
    ],
  },
  {
    title: "10. Contact and Complaints",
    paragraphs: [
      `To make a privacy request, contact ${CONTACT_EMAIL}. We may need to verify identity before releasing information.`,
      "If you are not satisfied with how we handle your data, you may complain to the Information Commissioner's Office (ICO).",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalDocumentPage
      title="Privacy Policy"
      lastUpdated={LAST_UPDATED}
      intro="This notice explains how we collect, use, and protect personal data in line with UK data protection law."
      sections={sections}
      testIdPrefix="privacy"
    />
  );
}
